<app-page-header subtitle="Materiaalbeheer"></app-page-header>
<div class="container-xl mt-4 mb-4">
    <mat-checkbox [checked]="noRawMaterial()" (change)="noRawMaterial.set($event.checked)">
        Zonder grondstof
    </mat-checkbox>
    @if (Roles.Codalt | hasRole) {
        <mat-checkbox class="ms-3" [checked]="showDeleted()" (change)="showDeleted.set($event.checked)">
            Alleen verwijderde materialen tonen
        </mat-checkbox>
    }
    @for (material of materials(); track material.id) {
        <div class="row border mb-2 p-2 rounded bg-light">
            <div class="col-24">
                <div class="row align-items-center mb-2">
                    <div class="col-24 col-md-6">
                        <h5 class="mb-0 d-flex align-items-center gap-2">
                            @if (material | materialProperty: 'color'; as color) {
                                <div class="material-color flex-shrink-0" [style.background-color]="color"></div>
                            }
                            {{ material.name }}
                            <small class="text-muted">{{ material | materialProperty: 'usage' }}</small>
                        </h5>
                    </div>
                    <div class="col-24 col-md-6">
                        <small class="text-muted">
                            Gebruikt in <strong>{{ material.plannings_count }}</strong> planningen
                        </small>
                    </div>
                    <div class="col-auto">
                        @if (material.deleted_at) {
                            <span class="badge bg-danger">Verwijderd</span>
                        } @else {
                            <span class="badge bg-success">Actief</span>
                        }
                        <small class="ms-2">#{{ material.id }}</small>
                    </div>
                </div>
            </div>

            <div class="col-24">
                <div class="table-responsive">
                    <table class="table table-sm table-hover mb-0 table-last-col table-add-row">
                        <thead class="table-light">
                            <tr>
                                <th>Grondstof</th>
                                <th>Type</th>
                                <th>Leverancier</th>
                                <th>Kleur</th>
                                <th class="text-end">OD-nummer</th>
                                <th class="text-end">Verbruik</th>
                                <th>Optioneel</th>
                                <th></th>
                            </tr>
                        </thead>
                        @for (rawMaterial of material.raw_materials; track rawMaterial.id) {
                            <tr [class.table-secondary]="rawMaterial.pivot?.optional === 1">
                                <td>
                                    @if (rawMaterial.color) {
                                        <div
                                            class="material-color d-inline-block align-middle me-1"
                                            [style.background-color]="rawMaterial.color.color"></div>
                                    }
                                    <strong>{{ rawMaterial.name }}</strong>
                                    <small class="ms-2">#{{ rawMaterial.id }} - #{{ rawMaterial.pivot?.id }}</small>
                                    @if (rawMaterial.deleted_at) {
                                        <span class="badge bg-danger-subtle text-danger ms-2">Verwijderd</span>
                                    }
                                    @if (rawMaterial.pivot?.deleted_at) {
                                        <span class="badge bg-danger-subtle text-danger ms-2">Link verwijderd</span>
                                    }
                                    @if (rawMaterial.material_type?.main) {
                                        <span class="badge bg-primary ms-2">Hoofd</span>
                                    }
                                </td>
                                <td>
                                    <small>
                                        {{ rawMaterial.material_type?.name }}
                                    </small>
                                </td>
                                <td>
                                    <small>{{ rawMaterial.supplier?.name }}</small>
                                </td>
                                <td>
                                    @if (rawMaterial.color) {
                                        <div class="d-flex align-items-center gap-2">
                                            <div
                                                class="material-color"
                                                [style.background-color]="rawMaterial.color.color"></div>
                                            <small>{{ rawMaterial.color.name }} ({{ rawMaterial.color.ral }})</small>
                                        </div>
                                    } @else {
                                        <small class="text-muted">-</small>
                                    }
                                </td>
                                <td class="text-end">
                                    <small>{{ rawMaterial.od_number ?? '-' }}</small>
                                </td>
                                <td class="text-end text-input" (click)="pivotConsumptionInput.focus()">
                                    <div class="d-flex align-items-center justify-content-end gap-1 h-100">
                                        <input
                                            #pivotConsumptionInput
                                            type="number"
                                            step="0.001"
                                            placeholder="-"
                                            [value]="rawMaterial.pivot?.consumption"
                                            (change)="
                                                updatePivotConsumption(rawMaterial.pivot, pivotConsumptionInput.value)
                                            " />
                                        <small>{{ consumptionTypeName(rawMaterial) }}</small>
                                    </div>
                                </td>
                                <td>
                                    @if (rawMaterial.pivot?.optional === 1) {
                                        <span
                                            class="badge bg-warning-subtle text-warning cursor-pointer"
                                            (contextmenu)="toggleOptional($event, rawMaterial.pivot)"
                                            title="Rechtsklik om te wisselen tussen optioneel en verplicht">
                                            Optioneel
                                        </span>
                                    } @else {
                                        <span
                                            class="badge bg-success-subtle text-success cursor-pointer"
                                            (contextmenu)="toggleOptional($event, rawMaterial.pivot)"
                                            title="Rechtsklik om te wisselen tussen optioneel en verplicht">
                                            Verplicht
                                        </span>
                                    }
                                </td>
                                <td>
                                    <button
                                        class="btn btn-sm btn-outline-danger"
                                        (click)="editRawMaterial(material.id, rawMaterial.id)"
                                        title="Verwijderen">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        }
                        <tr class="add-row">
                            <td colspan="8">
                                <button
                                    class="w-100"
                                    (click)="addChooseRawMaterial(material)"
                                    color="primary"
                                    mat-button>
                                    Grondstof toevoegen <i class="fas fa-plus"></i>
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    }

    <hr class="my-4" />
    <h4>Alle grondstoffen</h4>
    <div class="table-responsive">
        <table class="table table-sm table-hover table-striped mb-0">
            <thead class="table-light">
                <tr>
                    <th>#</th>
                    <th>Naam</th>
                    <th>Type</th>
                    <th>Leverancier</th>
                    <th>Kleur</th>
                    <th class="text-end">OD-nummer</th>
                    <th class="text-end">Verbruik</th>
                    <th class="text-end">Dikte</th>
                    <th class="text-end">Breedte</th>
                    <th>Certificaat</th>
                </tr>
            </thead>
            <tbody>
                @for (rm of allRawMaterials(); track rm.id) {
                    <tr [class.table-danger]="rm.deleted_at" [formGroup]="$any(rawMaterialForms().get(rm.id))">
                        <td>{{ rm.id }}</td>
                        <td>
                            <div class="d-flex gap-2 align-items-center">
                                @if (rm.color) {
                                    <div class="material-color" [style.background-color]="rm.color.color"></div>
                                }
                                <strong>{{ rm.name }}</strong>
                                @if (rm.deleted_at) {
                                    <span class="badge bg-danger-subtle text-danger ms-2">Verwijderd</span>
                                }
                            </div>
                        </td>
                        <td>
                            <small>{{ rm.material_type?.name ?? '-' }}</small>
                            @if (rm.material_type?.main) {
                                <span class="badge bg-primary ms-1">Hoofd</span>
                            }
                        </td>
                        <td>
                            <small>{{ rm.supplier?.name ?? '-' }}</small>
                        </td>
                        <td>
                            @if (rm.color) {
                                <div class="d-flex align-items-center gap-2">
                                    <div class="material-color" [style.background-color]="rm.color.color"></div>
                                    <small>{{ rm.color.name }} ({{ rm.color.ral }})</small>
                                </div>
                            } @else {
                                <small class="text-muted">-</small>
                            }
                        </td>
                        <td class="text-end">
                            <small>{{ rm.od_number ?? '-' }}</small>
                        </td>
                        <td
                            class="text-end text-input"
                            (click)="consumptionInput.focus()"
                            (contextmenu)="cycleConsumptionType($event, rm)"
                            title="Rechtsklik om verbruikseenheid te wijzigen">
                            <div class="d-flex align-items-center justify-content-end gap-1 h-100">
                                <input
                                    #consumptionInput
                                    type="number"
                                    step="0.001"
                                    placeholder="-"
                                    formControlName="consumption" />
                                <small>{{ rm.consumption_type?.name }}</small>
                            </div>
                        </td>
                        <td class="text-end text-input" (click)="thicknessInput.focus()">
                            <div class="d-flex align-items-center justify-content-end gap-1 h-100">
                                <input
                                    #thicknessInput
                                    type="number"
                                    step="0.01"
                                    placeholder="-"
                                    formControlName="thickness" />
                                <small>mm</small>
                            </div>
                        </td>
                        <td class="text-end text-input" (click)="widthInput.focus()">
                            <div class="d-flex align-items-center justify-content-end gap-1 h-100">
                                <input #widthInput type="number" step="0.01" placeholder="-" formControlName="width" />
                                <small>cm</small>
                            </div>
                        </td>
                        <td>
                            <small>{{ rm.certificate_number ?? '-' }}</small>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
